import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import { Content } from '../Content';

const Mobile = () => {
  const {
    app: { i18n },
    filter: { extraParams, isPaymentDefault },
  } = useStore();

  const actions = {
    second: {
      onClick: extraParams.resetPaymentParams,
      text: i18n.common.reset,
    },
  };

  return (
    <MobileScreen hasBackButton actions={isPaymentDefault ? undefined : actions} title={i18n.payment.label}>
      <Content />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
